<template>
    <div class="im--row bg-gray-100">
        <div class="im--row__cell hidden md:block">
            <!-- Empty cell -->
        </div>
        <div
            v-for="(column, index) in columns"
            :key="$uuid.v4(index)"
            class="im--row__cell"
        >
            <button
                type="button"
                class="im--button__simple"
                @click.prevent="onClickButton(column)"
            >
                {{ column.text }}
            </button>
        </div>
    </div>
</template>
<script>

export default {
    props: ['columns'],
    methods: {
        onClickButton(cell) {
            this.$emit('clicked', cell);
        }
    }
};
</script>
